import React from 'react';
import SlickSlider from 'react-slick';

import styles from './styles.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { subcomponent } from '@helpers';

const Slider = ({
    children,
    className = '',
    dots = false,
    infinite = true,
    speed = 500,
    slidesToShow = 1,
    slidesToScroll = 1,
    ...props
}) => {
    const sliderProps = { dots, infinite, speed, slidesToScroll, slidesToShow, ...props };
    const LeftSliderArrow = ({ onClick }) => (
        <button aria-label="Previous slide" onClick={onClick} className={`${styles.sliderArrow} ${styles.sliderArrowLeft}`}>
            <FontAwesomeIcon icon={['fal', 'chevron-left']} />
        </button>
    );

    const RightSliderArrow = ({ onClick }) => (
        <button aria-label="Next slide" onClick={onClick} className={`${styles.sliderArrow} ${styles.sliderArrowRight}`}>
            <FontAwesomeIcon icon={['fal', 'chevron-right']} />
        </button>
    );

    return (
        <SlickSlider
            className={`${styles.slider} ${className}`}
            {...sliderProps}
            prevArrow={<LeftSliderArrow />}
            nextArrow={<RightSliderArrow />}
        >
            {subcomponent(children, Slider.Item)}
        </SlickSlider>
    );
};

Slider.Item = ({ children }) => <div className={styles.sliderItem}>{children}</div>;

export default Slider;
